export enum WorkspacePermission {
  Member = 'member',
  Collaborator = 'collaborator',
  Owner = 'owner', // deprecated way of saying admin
  Admin = 'admin',
}
